import React from 'react' 
import floppy_disk_g from '../../assets/icons/floppy_disk_g.png'

export const FloppyDiskTransparent = ({...props}) => {
    return <img src={floppy_disk_g} alt='Floppy Disk' {...props} />
}